module.exports = __webpack_public_path__ + "static/tbe-50510b76adec5ecde4a3a1a54dd2c8f3.png";